import editor from "utils/issues/editor/multi_selector";

export function typeFilter(type) {
  return !["OR"].includes(type);
}
export default {
  ...editor(typeFilter),
  typeFilter,
};
